import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PaymentIntervalForm from '../../../components/forms/PaymentIntervalForm';
import {
  usePaymentIntervalById,
  useUpdatePaymentInterval,
} from '../../../hooks/usePaymentIntervalApi';
import { useNavigate, useParams } from 'react-router-dom';
import { PaymentIntervalDTO } from '../../../services/apiClient';

const PaymentIntervalEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = usePaymentIntervalById(id!);
  const updateMutation = useUpdatePaymentInterval();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Payment Intervals', href: '/admin/paymentintervals' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/paymentintervals');
    } catch (error) {
      console.error('Error updating PaymentInterval:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/paymentintervals"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.PaymentInterval.Edit"
    >
        {entityData ? (
          <PaymentIntervalForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/paymentintervals')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default PaymentIntervalEdit;
